import React, { useState } from 'react'
import './Change_Pin_Password.css'
import User_Info from '../../common_components/user_info/User_Info'
import { Form, Table } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import Select from 'react-select';

const Change_Pin_Password = () => {

    const {
        control,
        register,
        handleSubmit,
        getValues,
        setValue,
        setError,
        clearErrors,
        formState: { errors },
        reset,
        trigger,
    } = useForm();

    const [success,setSuccess] = useState(false)

    const options = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' }
    ];

    const optionsTwo = [
        { value: 'Need Pin', label: 'Need Pin' },
        { value: 'Need Password', label: 'Need Password' },
        { value: 'Need Both', label: 'Need Both' }
    ];

    return (
        <section className='Manage_My_Points Change_Pin_Password'>

            <div className='user_info_div'>
                <div className='row me-0 ms-0'>

                    <div className='col-lg-3 col-sm-8 col-12 my-3'>

                        <User_Info />
                    </div>

                </div>
            </div>

            <div className='note_info_div'>
                <div className='row me-0 ms-0'>

                    <div className='col-xxl-2 col-lg-3 col-md-6 order-lg-1 order-1 mb-2'>

                    </div>

                    <div className='col-xxl-8 col-lg-6 col-md-12 order-lg-2 order-3 mb-2'>

                        {success && (
                            <p className='success_text'>Reset Pin Password Change Successfully</p>
                        )}

                        <div className='box_holder'>

                            <div className='light_gray_div'>
                                <div className='btns_holder'>
                                    <div className='first_div'>
                                        <button className='blue_btn' onClick={() => {setSuccess(true)}}>Change Pin Password</button>
                                    </div>
                                    <div className='second_div'>
                                        <button className='blue_btn'>Reset Member ID</button>
                                    </div>
                                </div>
                            </div>

                            <div className='table-responsive fixed-height-scroll'>
                                <Table className='pin_table'>
                                    <thead>
                                        <tr>
                                            <th>Member ID</th>
                                            <th>Required</th>
                                            <th>Reset Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>asdasdasd</td>
                                            <td >fsdgsdfsdfsd </td>
                                            <td>dfsdf</td>
                                        </tr>
                                        <tr>
                                            <td>asdasdasd</td>
                                            <td >fsdgsdfsdfsd </td>
                                            <td>dfsdf</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>

                            <div className='add_details_div'>
                                <Form.Group className="common_form_group">
                                    <Controller
                                        name="category_id" // name of the field
                                        {...register("category_id", {
                                            required: "Category is required",
                                        })}
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={options}
                                                placeholder="Select Member Id"
                                            />
                                        )}
                                    />
                                </Form.Group>

                                <Form.Group className="common_form_group">
                                    <Controller
                                        name="category_id" // name of the field
                                        {...register("category_id", {
                                            required: "Category is required",
                                        })}
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={optionsTwo}
                                                placeholder="Required"
                                            />
                                        )}
                                    />
                                </Form.Group>

                                <div className='btn_holder'>
                                    <button className='blue_btn'>Add Details</button>
                                </div>

                            </div>


                        </div>
                    </div>

                    <div className='col-xxl-2 col-lg-3 col-md-6 order-lg-3 order-2 mb-2'>

                    </div>
                </div>
            </div>
        </section>
    )
}

export default Change_Pin_Password
